import { appConfig } from "../config";
import { FeatureAvailability, FeatureFlags, parseFeatureAvailability } from "../featureAvailability";
import { withAuth } from "./apiClient/http";

async function request(audience: string, features?: FeatureFlags): Promise<FeatureAvailability> {
  const response = await withAuth(`${appConfig.apiBaseUrl}/${encodeURIComponent(audience)}/feature-availability`, {
    method: features ? "PATCH" : "GET",
    cache: "no-store",
    ...(features ? { body: JSON.stringify({ features }) } : {}),
  });
  if (!response.ok) {
    throw new Error(`Unable to ${features ? "save" : "load"} feature availability (${response.status}). Please try again.`);
  }
  const body = await response.json();
  return parseFeatureAvailability(body.data);
}

export const featureAvailabilityService = {
  get: (audience: string) => request(audience),
  save: (audience: string, features: FeatureFlags) => request(audience, features),
};
